"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEventKey = getEventKey;
exports.callEventMethods = callEventMethods;
exports.getDataTransferFiles = getDataTransferFiles;

var _types = require("./types");

var _constants = require("../constants");

function getEventKey(event) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var value = defaultValue;

  if (event) {
    if (event.currentTarget) {
      value = event.currentTarget[key];
    } else if (event.target) {
      value = event.target[key];
    }
  }

  return value;
}

function callEventMethods(event) {
  for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  if (event && (0, _types.arrayHasItems)(keys)) {
    keys.forEach(function (k) {
      if ((0, _types.isStringMatch)(k, _constants.EVENT_METHODS) && event[k]) {
        event[k]();
      }
    });
  }
}

function getDataTransferFiles(event) {
  if (event) {
    var dataTransfer = event.dataTransfer,
        target = event.target;

    if (dataTransfer && dataTransfer.files && dataTransfer.files.length) {
      return Array.from(dataTransfer.files);
    }

    if (target && target.files && target.files.length) {
      return Array.from(target.files);
    }
  }

  return [];
}